import api from '@/libs/api'

let loadedAt = 0
let entryNumbers = []
const oneHour = 3600000

export default async (reload = false, getExtensionStatus = true) => {
  const limitAt = Date.now() - oneHour
  const canLoad = reload || !entryNumbers.length || limitAt > loadedAt
  if (!canLoad) return structuredClone(entryNumbers)

  const rows = await api.getEntryNumbers(getExtensionStatus).catch(() => ({})).then((entryNumbers) => Object.values(entryNumbers))
  if (!rows.length) return structuredClone(entryNumbers)

  entryNumbers = rows
  loadedAt = Date.now()
  return structuredClone(entryNumbers)
}
